var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 16C25.2571 16 25.8856 16 26.2761 16.3905C26.6667 16.7811 26.6667 17.4096 26.6667 18.6667V29.3333C26.6667 30.5904 26.6667 31.2189 26.2761 31.6095C25.8856 32 25.2571 32 24 32M24 16C22.7429 16 22.1144 16 21.7239 16.3905C21.3333 16.7811 21.3333 17.4096 21.3333 18.6667V29.3333C21.3333 30.5904 21.3333 31.2189 21.7239 31.6095C22.1144 32 22.7429 32 24 32M24 16V12M24 32V36M33.3333 14.6667C34.5904 14.6667 35.2189 14.6667 35.6095 15.0572C36 15.4477 36 16.0763 36 17.3333V20C36 21.2571 36 21.8856 35.6095 22.2761C35.2189 22.6667 34.5904 22.6667 33.3333 22.6667M33.3333 14.6667C32.0763 14.6667 31.4477 14.6667 31.0572 15.0572C30.6667 15.4477 30.6667 16.0763 30.6667 17.3333V20C30.6667 21.2571 30.6667 21.8856 31.0572 22.2761C31.4477 22.6667 32.0763 22.6667 33.3333 22.6667M33.3333 14.6667V12M33.3333 22.6667V25.3333M14.6667 21.3333C15.9237 21.3333 16.5523 21.3333 16.9428 21.7239C17.3333 22.1144 17.3333 22.7429 17.3333 24V26.6667C17.3333 27.9237 17.3333 28.5523 16.9428 28.9428C16.5523 29.3333 15.9237 29.3333 14.6667 29.3333M14.6667 21.3333C13.4096 21.3333 12.7811 21.3333 12.3905 21.7239C12 22.1144 12 22.7429 12 24V26.6667C12 27.9237 12 28.5523 12.3905 28.9428C12.7811 29.3333 13.4096 29.3333 14.6667 29.3333M14.6667 21.3333V18.6667M14.6667 29.3333V32",
    stroke: "#FD532F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/icon1.9af84aef4553155c5f9b25ddadda62e1.svg";
export { ForwardRef as ReactComponent };